function isTouch() {
  return ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
}

const tag = 'product-card'
const swatchProperty = 'data-card-switcher-';
if (!customElements.get(tag)) {
  customElements.define(
    tag,
    class ProductListItem extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initSwiper();
        this.quickAdds = Array.from(this.querySelectorAll('.card-quickbuy__static, .card-quickbuy__options a'));
        this.productTitle = this.querySelector('[data-product-card-title]');
        this.productSingleImage = this.querySelector('[data-product-card-image]');
        this.subtitle = this.querySelector('[data-product-card-subtitle]');
        this.slidesWrapper = this.querySelector('[data-product-card-slides]');
        this.links = Array.from(this.querySelectorAll('[data-product-card-link]'));
        this.price = this.querySelector('.sa-price__regular');
        this.salePrice = this.querySelector('.sa-price__sale');
        this.swatches = Array.from(this.querySelectorAll('.swatch-preview'));

        this.swatches.forEach((swatch) => {
          const title = swatch.getAttribute(swatchProperty+'title');
          const subtitle = swatch.getAttribute(swatchProperty+'subtitle');
          const availability = swatch.getAttribute(swatchProperty+'available').split(',') || [];
          const variants = swatch.getAttribute(swatchProperty+'variants')?.split(',') || [];
          const price = swatch.getAttribute(swatchProperty+'price');
          const compare_at_price = swatch.getAttribute(swatchProperty+'compare-at-price');
          let swatch_images = swatch.getAttribute(swatchProperty+'images').split('|');
          const url = swatch.href;

          if (!isTouch()) {
            swatch.addEventListener('mouseenter', () => {
              swatch_images.forEach((image) => {
                const img = new Image();
                img.src = image.indexOf('//') === 0 ? `https:${image}` : image;
              })
            });
          }

          swatch.addEventListener('click', (ev) => {
            ev.preventDefault();
            ev.stopPropagation();

            this.swatches.forEach((swatch) => swatch.classList.remove('active'));
            swatch.classList.add('active');

            if (this.productTitle && title) {
              this.productTitle.innerHTML = title;
            }

            if (this.subtitle && subtitle) {
              this.subtitle.innerHTML = subtitle;
            }

            if (this.price && price) {
              this.price.innerHTML = price;
            }

            if (this.salePrice && compare_at_price) {
              this.salePrice.innerHTML = compare_at_price;
            }

            if (this.links.length && url) {
              this.links.forEach((link) => {
                link.href = url;
              })
            }

            if (this.quickAdds.length && variants.length) {
              this.quickAdds.forEach((quickAdd, i) => {
                const available = availability[i] || 'true';

                if (available === 'true') {
                  quickAdd.setAttribute('data-variant-add', variants[i]);
                  quickAdd.classList.remove('disabled');
                } else {
                  quickAdd.removeAttribute('data-variant-add');
                  quickAdd.classList.add('disabled');
                }

                if (quickAdd.classList.contains('card-quickbuy__static')) {
                  quickAdd.innerHTML = `<span>${available === 'true' ? 'Add to Cart' : 'Out Of Stock'}</span>`;
                  const outer = quickAdd.closest('.quickbuy-inline, .card-quickbuy');
                  if (outer) {
                    if (available === 'true') {
                      outer.classList.remove('quickbuy-inline--disable');
                    } else {
                      outer.classList.add('quickbuy-inline--disable');
                    }
                  }
                }
              });
            }

            if (this.productSingleImage && swatch_images.length) {
              this.productSingleImage.innerHTML = '';
              const img = document.createElement('img');
              img.src = swatch_images[0];
              img.loading = 'lazy';
              this.productSingleImage.appendChild(img);
            } else if (this.slidesWrapper && swatch_images.length) {
              this.slidesWrapper.innerHTML = '';
              this.swiper?.destroy();
              swatch_images.forEach((image, i) => {
                const slide = document.createElement('div');
                const link = document.createElement('a');
                link.href = url;
                link.className = 'product-card-image';

                const img = document.createElement('img');
                img.src = image;
                img.loading = 'lazy';

                link.appendChild(img);
                slide.appendChild(link);
                slide.classList.add('swiper-slide');
                this.slidesWrapper.appendChild(slide);
              })

              this.initSwiper();
            }
          })
        })
      }

      initSwiper() {
        const swiperEl = this.querySelector(".swiper");
        if (!swiperEl) return;

        this.swiper = new Swiper(swiperEl, {
          draggable: true,
          slidesPerView: 1,
          spaceBetween: 0,
          grabCursor: false,
          speed: 300,
          loop: true,
          breakpoints: {
            1024: {
              draggable: false,
            },
          },
          navigation: {
            nextEl: this.querySelector('.carousel__arrows .arrow--next'),
            prevEl: this.querySelector('.carousel__arrows .arrow--prev')
          },
          scrollbar: {
            el: this.querySelector('.carousel__progress-bar'),
          },
        });

        if (!isTouch()) {
          this.swiper.el.addEventListener('mouseenter', () => {
            if (this.swiper.isBeginning && this.swiper.slides.length > 1) {
              this.swiper?.slideToLoop(1, 0);
            }
          });

          this.swiper.el.addEventListener('mouseleave', () => {
            this.swiper?.slideToLoop(0, 0);
          });
        }
      }

      disconnectedCallback() {
        this.swiper?.destroy()
      }
      preloadImages(imageUrls) {
        for (let i = 0; i < imageUrls.length; i++) {
          const img = new Image();
          img.src = imageUrls[i];
        }
      }
    }
  );
}
